import React from 'react'
import { Create, NumberInput, required, SimpleForm, TextInput, useNotify, useRedirect, useTranslate } from 'react-admin'
import { Grid, Hidden } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'

export const BasesCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.bases') }
    })
    redirect('/bases')
  }

  const onError = () => {
    notify('ra.notification.created_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.bases') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_base')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.external_id')}>
              <NumberInput label='' source='external_id' fullWidth />{' '}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.journal_id')}>
              <NumberInput label='' source='journal_id' fullWidth />{' '}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.url')}>
              <TextInput source='url' label={false} fullWidth />
            </EditInputsWrap>
            <Hidden mdDown>
              <Grid item md={8} />
            </Hidden>
            <EditInputsWrap label={translate('ra.field.countries')}>
              <JsonInput source='countries' width='auto' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.currencies')}>
              <JsonInput source='currencies' width='auto' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.products')}>
              <JsonInput source='products' width='auto' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.login')}>
              <JsonInput source='login' width='auto' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.config')}>
              <JsonInput source='config' width='auto' />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
